const iconTarget = `
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
    <g fill="none">
      <path d="M0 0h30v30H0z"/>
      <g class="icon-color" fill-rule="nonzero" transform="translate(3 2)" fill="#008AB7">
        <path d="M9.207 6.578c5.086 0 9.208 4.124 9.208 9.211 0 5.087-4.122 9.211-9.208 9.211C4.122 25 0 20.876 0 15.789c0-5.087 4.122-9.211 9.207-9.211zm.01 2.411a6.832 6.832 0 0 0-6.836 6.829 6.832 6.832 0 0 0 6.836 6.829 6.832 6.832 0 0 0 6.836-6.83A6.832 6.832 0 0 0 9.217 8.99z"/>
        <path d="M9.198 10.629c2.902 0 5.254 2.336 5.254 5.218s-2.352 5.218-5.254 5.218c-2.902 0-5.255-2.336-5.255-5.218s2.353-5.218 5.255-5.218zm.048 2.006c-1.794 0-3.25 1.416-3.25 3.164 0 1.747 1.456 3.163 3.25 3.163s3.25-1.416 3.25-3.163c0-1.748-1.456-3.164-3.25-3.164z"/>
        <ellipse cx="9.333" cy="15.76" rx="1.774" ry="1.717"/>
        <path stroke="#008AB7" stroke-width="1.928" d="m9.207 15.789 9.208-9.211"/>
        <path d="M17.104 7.9V3.944L21.047 0v3.945H25l-3.953 3.954z"/>
      </g>
    </g>
  </svg>
`

export default iconTarget
